export const SECONDS_HAND_TABS = ["standard", "special"];
